/**
 * Normalizes /infoowner/list payload into { active, inactive }.
 * Supports both the split object shape and a legacy flat array.
 */
export function normalizeInfoOwnerListPayload(payload) {
  if (Array.isArray(payload)) {
    const active = [];
    const inactive = [];
    payload.forEach((owner) => {
      if (owner?.status === false) inactive.push(owner);
      else active.push({ ...owner, status: true });
    });
    return { active, inactive };
  }
  if (payload && typeof payload === 'object') {
    return {
      active: Array.isArray(payload.active) ? payload.active : [],
      inactive: Array.isArray(payload.inactive) ? payload.inactive : [],
    };
  }
  return { active: [], inactive: [] };
}

export function commitInfoOwnerLists(commit, payload) {
  const { active, inactive } = normalizeInfoOwnerListPayload(payload);
  commit('SET_INFO_OWNERS', active);
  commit('SET_INACTIVE_INFO_OWNERS', inactive);
}

function isDuplicateEmailFieldError(message) {
  const normalized = String(message).trim().toLowerCase();
  return normalized === 'already exist' || normalized === 'already exists';
}

function formatOwnerSaveMessage(message) {
  const text = String(message || '').trim();
  if (text.toLowerCase().replace(/\.$/, '') === 'email is already exist') {
    return 'Email already exists';
  }
  return text;
}

/**
 * Normalizes API validation payload (index0) into flat field → message map.
 */
export function normalizeOwnerFormErrors(index0 = {}, responseMessage = '') {
  const errors = {};
  Object.keys(index0).forEach((field) => {
    const value = index0[field];
    let message = Array.isArray(value) ? value.join(', ') : String(value || '');
    if (field === 'email' && isDuplicateEmailFieldError(message) && responseMessage) {
      message = formatOwnerSaveMessage(responseMessage);
    }
    if (message) {
      errors[field] = message;
    }
  });
  return errors;
}

/**
 * Resolves snackbar copy for owner save failures.
 */
export function resolveOwnerSaveErrorMessage(response, fieldErrors = {}) {
  if (response?.message) return formatOwnerSaveMessage(response.message);
  const firstField = Object.keys(fieldErrors)[0];
  if (firstField && fieldErrors[firstField]) return fieldErrors[firstField];
  return 'Please fix the highlighted fields';
}

/**
 * Parses add/edit owner API error responses into field errors and snackbar text.
 */
export function parseOwnerSaveErrorResponse(response) {
  const index0 = response?.data?.[0]?.index0;
  const fieldErrors = index0 ? normalizeOwnerFormErrors(index0, response?.message) : {};
  return {
    fieldErrors,
    message: resolveOwnerSaveErrorMessage(response, fieldErrors),
  };
}
